import { render } from "./RecentPanel.vue?vue&type=template&id=3c865422"
import script from "./RecentPanel.vue?vue&type=script&lang=js"
export * from "./RecentPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__